// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInAnonymously } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBKWWgAKztTyHG1JO3yjd_9NJ49rpVxLhs',
  authDomain: 'rentvibe-reviews.firebaseapp.com',
  projectId: 'rentvibe-reviews',
  storageBucket: 'rentvibe-reviews.firebasestorage.app',
  messagingSenderId: '587111866270',
  appId: '1:587111866270:web:8e5d1f7a704fd46c96c08f',
  measurementId: 'G-JQGHVC7QP4',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Anonymous sign in function
export const signInAnonymous = async () => {
  try {
    const result = await signInAnonymously(auth);
    return result.user;
  } catch (error) {
    console.error('Anonymous sign-in error:', error);
    throw error;
  }
};

// Export the app for potential future use
export default app;
